module.exports = __webpack_public_path__ + "img/logo_mf.dbfb2c10.svg";